import { useMessenger } from 'features/chat/contexts/chatMessengerContext'
import { goToChatBottom } from 'features/chat/functions'
import useChat from 'features/chat/hooks/useChat'
import { TChatListData, TGetChatMessage } from 'features/chat/types'
import { FC } from 'react'
import { useAppDispatch } from 'hooks'
import { updateChatListById } from 'features/chat/reducer/ChatSlice'
import ReplyChatMsg from './ChatMessageItem/ReplyChatMsg'
import ChatMessageList from './ChatMessageList'
import ChatMsgFooter from './ChatMsgFooter'

const ChatMessageBody: FC<{
 leadId: any
 isDirectChat?: boolean
 data?: TGetChatMessage[]
 fetchMore?: () => void
 hasMore?: boolean
 total?: number
 isLoading?: boolean
}> = ({
 data,
 isDirectChat = false,
 isLoading,
 fetchMore,
 hasMore,
 total,
 leadId,
}) => {
 const dispatch = useAppDispatch()

 return (
  <div className="chat-messenger-body">
   <div className="tch-chat-block">
    <div className="tch-chat-body">
     <ChatMessageList
      id={leadId}
      data={data}
      hasMore={hasMore}
      fetchMore={fetchMore}
      total={total}
      isLoading={isLoading}
     />
    </div>
    <div>
     {/* {data?.replyChat && (
      <ReplyChatMsg
       data={data.replyChat as any}
       onClose={() =>
        dispatch(
         updateChatListById({
          id: isDirectChat ? data?.userId : data?.groupId,
          data: { replyChat: null },
          isDirect: isDirectChat,
         }),
        )
       }
       isDirect={isDirectChat}
       senderId={isDirectChat ? data?.userId : null}
      />
     )} */}
    </div>
    <ChatMsgFooter onSendMsg={goToChatBottom} id={leadId} />
   </div>
  </div>
 )
}

export default ChatMessageBody
